<template>
  <div class="edit-league section">
    <template v-if="league">

      <div class="level">
        <div class="level-left">
          <h1 class="title">Edit {{ league.en.title }}</h1>
        </div>

        <div class="level-right">
          <div class="control is-grouped">

            <p class="add-language control">

              <div class="control has-addons">
                <span class="select">
                  <select v-model="newLanguage" class="form-control">
                    <option disabled hidden selected="{{!newLanguage}}">Select...</option>
                    <option v-for="language in languages" v-bind:value="language.code">
                      {{ language.title }}
                    </option>
                  </select>
                </span>
                <button v-on:click="addLanguage" class="button is-primary">Add language</button>
              </div>

            </p>
            <p class="control">
              <button v-on:click="update" class="button is-success">Update</button>
            </p>
          </div>
        </div>
      </div>


      <div class="lang" v-for="lang in league.languages">
        <h2 class="subtitle" v-if="lang != 'en'">
          {{lang | languageFromCode}}
          <small v-on:click="deleteLanguage(lang)">Delete</small>
        </h2>

        <div class="control is-grouped">
          <p class="control is-expanded">
            <label class="label">Title</label>
            <input v-model="league[lang].title"
              type="text" placeholder="League title"
              class="input" />
          </p>
          <p class="control is-expanded">
            <label class="label">Subtitle</label>
            <input v-model="league[lang].subtitle"
              type="text" placeholder="Subtitle"
              class="input" />
          </p>
        </div>

        <label class="label">Labels</label>
        <div class="control is-grouped">
          <p class="control is-expanded">
            <input v-model="league[lang].countryLabel"
              type="text" placeholder="Country label"
              class="input" />
          </p>

          <p class="control is-expanded">
            <input v-model="league[lang].ministerLabel"
              type="text" placeholder="Minister label"
              class="input" />
          </p>

          <p class="control is-expanded">
            <input v-model="league[lang].quotaLabel"
              type="text" placeholder="Quota label"
              class="input" />
          </p>

          <p class="control is-expanded">
            <input v-model="league[lang].quotaUnitLabel"
              type="text" placeholder="Quota unit label"
              class="input" />
          </p>

          <p class="control is-expanded">
            <input v-model="league[lang].fishLabel"
              type="text" placeholder="Fish species label"
              class="input" />
          </p>
        </div>

        <div v-if="lang == 'en'">

          <label class="label">Year</label>
          <p class="control">
            <span class="select">
              <select v-model="league.year">
                <option>Select year...</option>
                <option v-for="year in years" number>{{ year }}</option>
              </select>
            </span>
          </p>

          <label class="label">Region</label>
          <p class="control">
            <span class="select">
              <select v-model="league.region">
                <option>Select region...</option>
                <option v-for="region in regions" number>{{ region }}</option>
              </select>
            </span>
          </p>
        </div>

        <div class="countries">
          <label class="label">Countries <small>(Generated from data)</small></label>
          <div>
            <league-countries :region="league.region" :year="league.year" :lang="lang"></league-countries>
          </div>

        </div>

        <div class="fish-species" v-if="fishes1">
          <label class="label">Fish</label>
          <div>
            <span class="tag is-primary is-medium" v-for="(key, fish) in league.fishes" v-if="lang == 'en'">
              {{key}}
              <button v-on:click="deleteFish(key)" class="delete"></button>
            </span>

            <div class="add-fish" v-if="lang == 'en'">
              <div class="control has-addons">
                <span class="select">
                  <select v-model="newFish">
                    <option disabled hidden selected="{{!newFish}}">Select...</option>
                    <option v-for="fish in fishes1">
                      {{ fish.en }}
                    </option>
                  </select>
                </span>
                <button v-on:click="addFish" class="button is-primary">Add fish</button>
              </div>
            </div>

          </div>

          <div v-if="lang != 'en'">
            <p v-for="(key, fish) in league.fishes">
              <input v-model="fishes1[key][lang]" class="input" :placeholder="key" v-if="fishes1"/>
            </p>
          </div>

        </div>

      </div>

      <p class="control">
        <button v-on:click="update" class="button is-success">Update</button>
      </p>

    </template>
  </div>

</template>

<script>
import LeagueCountries from '../components/LeagueCountries.vue'
import fb from 'firebase'
import languages from '../lib/languages'
import _ from 'underscore'

export default {

  components: {
    LeagueCountries
  },

  data: function () {
    return {
      league: null,
      languages: languages,
      key: this.$route.params.key,
      newLanguage: 0,
      newFish: null,
      years: [],
      regions: [],
      fishes1: {},
    }
  },

  ready: function() {
    var self = this

    fb.database().ref('leagues/' + this.key).once('value')
      .then(function(snapshot) {
        self.league = snapshot.val()
      }).then(function() {
        self.fetchYears()
        self.fetchRegions()
        self.fetchFish()
      })
  },

  methods: {

    update: function() {
      var leagueRef = fb.database().ref('leagues').child(this.key)
      leagueRef.set(this.league)
      this.updateFishes()
      this.$broadcast('update')
      this.$alert('Updated')
    },

    updateFishes: function() {
      let self = this
      var fishUpdateRef = {}
      _.each(this.league.fishes, function(value, key) {
        fishUpdateRef[key] = self.fishes1[key]
      })
      fb.database().ref('fishes/').update(fishUpdateRef)
    },

    addLanguage: function() {
      var lang = this.newLanguage
      if (lang) {
        var league = this.league
        league.languages.push(lang)
        league[lang] = league.en

        var leagueRef = fb.database().ref('leagues').child(this.key)
        leagueRef.set(league)
      }
    },

    deleteLanguage: function(language) {
      let league = this.league

      league.languages = _.filter(league.languages, function(lang) {
        return lang != language
      })
      league[language] = null

      var leagueRef = fb.database().ref('leagues').child(this.key)
      leagueRef.set(league)
    },

    addFish: function() {
      var fish = this.newFish
      if (!this.league.fishes) {
        this.league.fishes = {}
      }
      this.league.fishes[fish] = true
      this.update()
    },

    deleteFish: function(fishKey) {
      this.league.fishes[fishKey] = null
      this.update()
    },

    fetchFish: function() {
      let self = this

      fb.database().ref('fishes').on('value', function(snapshot) {
        self.fishes1 = snapshot.val()
      })
    },

    fetchRegions: function() {
      let self = this

      fb.database().ref('regions').on('child_added', function(snapshot) {
        let region = snapshot.key
        self.regions.push(region)
      })
    },

    fetchYears: function() {
      self = this
      fb.database().ref('periods').on('child_added', function(snapshot) {
        self.years.push(snapshot.key)
      })
    }
  }
}
</script>

<style>
  .lang {
    background: #ddeff5;
    padding: 1.5rem;
    border-bottom: 1px solid rgba(0,0,0,0.15);
  }

  .tag {
    margin-right: 5px;
    margin-bottom: 5px
  }

  .add-fish {
    margin-top: 1rem;
  }
</style>



/** WEBPACK FOOTER **
 ** LeagueEdit.vue?29ea23e1
 **/